







import { Component } from "vue-property-decorator";
import AppVue from "@/AppVue.vue";
import HomeView from "./modules/HomeView.vue";

@Component({
  components: {
    HomeView,
  },
})
export default class App extends AppVue {
  get layout() {
    return "empty-layout";
  }
}
